<template>
    <div class="manual-wrapper">
        <slot name="title" />
        <div class="width-expander">
            <div v-if="manualCableSelectionOfferings.length > 0"  class="flex-wrapper">
                <div v-if="activeProductKey === 'AG52' || (activeProductKey === 'AG-CBL' && selectedTypeOfReplacementCable.includes('52'))" class="new-cable-message">{{ webstoreContent.cartPage.new_ag_cable_message }}</div>
                <div class="tile-wrapper" v-for="(cableInfo, count) in manualCableSelectionOfferings" :key="count" :id="cableInfo.skuText">
                    <div v-if="!isCableAccessoriesPage">
                        <CableSelectQuantity
                            :ref="cableInfo.skuText.replace(/\-/g, '')"
                            :imageSource="cableInfo.image"
                            :productName="cableInfo.productName"
                            :skuText="cableInfo.skuText"
                            :maxPurchasableQuantity="cablesNeededCount"
                            :minPurchasableQuantity="0"
                            :maxedOut="cablesNeededCount === cablesSelectedCount"
                            :startingNumber="(manualSelectionData && cableInfo.skuText in manualSelectionData) ? manualSelectionData[cableInfo.skuText] : 0"
                        />
                    </div>
                    <div v-else>
                        <CableSelectQuantity
                            :ref="cableInfo.skuText.replace(/\-/g, '')"
                            :imageSource="cableInfo.image"
                            :productName="cableInfo.productName"
                            :skuText="cableInfo.skuText"
                            :maxPurchasableQuantity="Number.MAX_SAFE_INTEGER"
                            :minPurchasableQuantity="0"
                            :maxedOut="false"
                            :startingNumber="(manualSelectionData && cableInfo.skuText in manualSelectionData) ? manualSelectionData[cableInfo.skuText] : 0"
                        />
                    </div>
                </div>
            </div>
            <div v-else>
                <p>{{ webstoreContent.cartPage.no_cables }} {{ isCableAccessoriesPage && webstoreContent.cartPage.cable_type }}</p>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import CableSelectQuantity from '../checkouts/webstore/cable-select-quantity';

    export default {
        components: {CableSelectQuantity},

        props: {
            cableSkuToNames: {
                required: false,
                default: {},
            },
            isCableAccessoriesPage: {
                required: false,
                default: false
            },
            noProductImage: {
                required: true,
                default: {}
            },
            webstoreContent: {
                required: true,
                default: {}
            },
            selectedTypeOfReplacementCable: {
                required: false,
                default: 'B series'
            }
        },

        data() {
            return {
                compiledManualData: {},
            }
        },

        computed: {
            ...mapGetters([
                'activeProductKey',
                'activeOfferKey',
                'activeProductInfo',
            ]),

            cablesNeededCount() {
                return this.$store.getters[`${this.activeProductKey}${this.activeOfferKey}CableSelection/base/cablesNeededCount`];
            },

            cablesSelectedCount() {
                return this.$store.getters[`${this.activeProductKey}${this.activeOfferKey}CableSelection/base/cablesSelectedCount`];
            },

            manualSelectionData() {
                return this.$store.getters[`${this.activeProductKey}${this.activeOfferKey}CableSelection/manualSelection/manualSelectionData`];
            },

            clearManualSelectionData() {
                return this.$store.commit(
                    `${this.activeProductKey}${this.activeOfferKey}CableSelection/manualSelection/clearManualSelectionData`
                );
            },

            manualCableSelectionOfferings() {
                let cableSelectionOfferings = [];
                if (this.isCableAccessoriesPage) {
                    for (let cable_content in this.activeProductInfo.offerings) {
                        let cableInfo = {
                            image: (this.activeProductInfo.offerings[cable_content].offerImage && this.activeProductInfo.offerings[cable_content]["offerImage"][0]) || (this.noProductImage.fields.file.url),
                            productName: this.activeProductInfo.offerings[cable_content]["offerName"],
                            skuText: this.activeProductInfo.offerings[cable_content]["offerKey"]
                        }
                        if (!['VG-CBL', 'AG-CBL'].includes(this.activeProductKey)) {
                            cableSelectionOfferings.push(cableInfo)
                        } else if (this.activeProductInfo.offerings[cable_content]) {
                            if (this.addCableToSelections(this.activeProductInfo.offerings[cable_content])) {
                                cableSelectionOfferings.push(cableInfo)
                            }
                        }
                    }
                    return this.sortCables(cableSelectionOfferings);
                }
                for (let cable_content of this.activeProductInfo.cables) {
                    let cableInfo = {
                        image: (cable_content.image && cable_content.image[0]) || (this.noProductImage.fields.file.url),
                        productName: cable_content.name,
                        skuText: cable_content.key,
                    }
                    cableSelectionOfferings.push(cableInfo)
                }
                return this.sortCables(cableSelectionOfferings);
            },
        },

        methods: {
            setManuallySelectedCableAndQuantity(payload) {
                this.$store.commit(`${this.activeProductKey}${this.activeOfferKey}CableSelection/manualSelection/setManuallySelectedCableAndQuantity`, payload);
                if (this.manualSelectionData && Object.keys(this.manualSelectionData).length > 0) {
                    this.compiledManualData = {};
                    Object.keys(this.manualSelectionData).forEach(key => {
                        let value = this.manualSelectionData[key];
                        let accessor = (this.cableSkuToNames && this.cableSkuToNames[key]) || key;
                        if (value !== 0) {
                            this.compiledManualData[accessor] = { qty: value }
                        }
                    });
                }
            },

            addCableToSelections(cable_content) {
                if (this.activeProductKey == 'VG-CBL') {
                    if (this.selectedTypeOfReplacementCable.includes("B") && cable_content.type.includes("B")
                        || this.selectedTypeOfReplacementCable.includes("C") && cable_content.type.includes("C")) {
                        return true;
                    }
                } else {
                    if (this.selectedTypeOfReplacementCable.includes("46/26") && cable_content.offerKey.includes("AG-A")
                        || this.selectedTypeOfReplacementCable.includes("52") && cable_content.offerKey.includes("-B")) {
                        return true;
                    }
                }
                return false;
            },

            sortCables(cablesArray) {
                return cablesArray.sort(function(a, b) {
                    var textA = a.productName.toUpperCase();
                    var textB = b.productName.toUpperCase();
                    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                });
            },

            buildWatchEvents: function() {
                for (let cable of this.manualCableSelectionOfferings) {
                    this.$watch(`$refs.${cable.skuText.replace(/\-/g, '')}.$refs.selectedQuantity.quantity`, function(selectedQuantity) {
                        this.setManuallySelectedCableAndQuantity({cableKey: cable.skuText, quantity: selectedQuantity});
                    });
                }
            },

            clearVisualData() {
                Object.values(this.$refs).forEach(ref => {
                    if (ref.$refs && ref.$refs['selectedQuantity']) {
                        ref.$refs['selectedQuantity'].reset();
                    }
                })
            }
        },

        mounted() {
            // when using $watch + string interpolation, square Array brackets are not interpreted correctly by Vue, remove them
            for (let ref in this.$refs) {
                this.$refs[ref] = this.$refs[ref][0];
            }
            this.buildWatchEvents();
        },

        created() {
            this.unsubscribe = this.$store.subscribe((mutation) => {
                if (
                    [
                        `${this.activeProductKey}${this.activeOfferKey}CableSelection/base/clearTotalCablesSubmittedData`,
                        `${this.activeProductKey}${this.activeOfferKey}CableSelection/manualSelection/clearManualSelectionData`
                    ].includes(mutation.type)
                ) 
                {
                    this.clearVisualData();
                }
            });
        },
    }
</script>

<style scoped>
    .featured-product {
        padding-bottom: 80px;
        padding-left: 15px;
        padding-right: 15px;
    }

    .flex {
        display: flex;
    }

    .flex-wrapper {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
    }

    .tile-wrapper {
        margin: 0;
        width: 290px;
        margin: 0;
        margin-right: 16px;
        margin-left: 7px;
    }

    @media (min-width: 736px) {
        .width-expander {
            width: 100%;
            margin-bottom: 50px;
        }
        .manual-wrapper {
            padding-right: 20px;
        }
        .flex-wrapper {
            padding-left: 3px;
            padding-top: 20px;
        }
        .new-cable-message {
            margin-top: 20px;
            margin-bottom: 40px;
            color: #9F6000;
            font-weight: bold;
            background-color: #FEEFB3;
            padding: 20px;
            width: fit-content;
            border-radius: 5px;
        }
    }
</style>